var PD = PD || {};

PD.storage = (function(storage){
  localforage.config({
    name: "CleanCalculator",
    version: 1
  });
  // proxy a bunch of methods from localforage -> PD.storage
  // we prefer Promises, but you can use Node-style callbacks if necesarry
  // IMPORTANT: do not use .catch, not supported in IE9-. Use ["catch"] instead
  var methods = {
    "get": "getItem", // ('key', value)
    "set": "setItem", // ('key')
    "remove": "removeItem", // ('key')
    "delete": "removeItem", // ('key')
    "clear": "clear" // ()
  };
  for (var k in methods) {
    storage[k] = localforage[methods[k]].bind(localforage);
  }

  return storage;

  /**
   * Example code:
   *
   * PD.storage.set("foo", "bar")
   *   .then(function(){
   *     // storage now has key "foo" set to "bar"
   *     return PD.storage.get("foo")
   *   })
   *   .then(function(value){
   *     console.log(value); // > "bar"
   *   })["catch"](function(err){
   *     console.error("Something went horribly wrong");
   *     console.error(err);
   *   });
   *
   * or with callbacks:
   *
   * PD.storage.set("foo", "bar", function(err){
   *   // storage now has key "foo" set to "bar"
   *   if (err) {
   *     console.error("Something went horribly wrong");
   *     console.error(err);
   *     return;
   *   }
   *   PD.storage.get("foo", function(err, value){
   *     if (err) {
   *       ...
   *     }
   *     console.log(value); // > "bar"
   *   });
   * });
   */
})(PD.storage || {});